module.exports = __webpack_public_path__ + "static/cloud-computing-e25ebbe011b06ba3029b070c22121836.png";